export interface Volume {
  number: string
  title: string
  summary: string
  contents: string[]
}

export const volumes: Volume[] = [
  {
    number: '01',
    title: 'Ballet Foundations',
    summary:
      'The technical base that lets a new student start with confidence and safety.',
    contents: [
      'Foundational positions and posture',
      'Plié, tendu, relevé progressions',
      'Port de bras and arm-leg coordination',
      '12-week progressive system',
      'Mini-assessments for early progress',
    ],
  },
  {
    number: '02',
    title: 'Barre Work System',
    summary:
      'Barre sequences already ordered, already progressive, ready to teach as written.',
    contents: [
      'Plié, tendu, dégagé combinations',
      'Rond de jambe, frappé, grand battement',
      'Complete sequences with cues',
      'Weekly progressions',
      'Common-error corrections',
    ],
  },
  {
    number: '03',
    title: 'Center Practice & Balance',
    summary:
      'Work away from the barre, guided from the first step to the closing pose.',
    contents: [
      'Center posture and axis control',
      'Temps lié and adagio sequences',
      'Balance work and focus techniques',
      'Musicality and movement fluidity',
      'Technical corrections',
    ],
  },
  {
    number: '04',
    title: 'Across-the-Floor & Traveling',
    summary:
      'What students enjoy most, finally organized instead of improvised.',
    contents: [
      'Ballet walks, chassé, pas de bourrée',
      'Glissade and balancé patterns',
      'Diagonals at every level',
      'Spatial organization',
      'Arm coordination',
    ],
  },
  {
    number: '05',
    title: 'Jumps, Turns & Strength',
    summary:
      'The demanding technical work, built around safety and steady progression.',
    contents: [
      'Jump preparation and landing',
      'Sautés, changements, assemblés',
      'Pirouette preparation',
      'Core and ankle stability',
      'Safety corrections',
    ],
  },
  {
    number: '06',
    title: 'Master Lesson Plans',
    summary:
      'Complete classes covering every level, age and teaching situation you face.',
    contents: [
      '30-minute, 45-minute, 60-minute classes',
      'Beginner, basic, intermediate',
      'Mixed-level sessions',
      'Emergency and recital prep',
      'Assessment classes',
    ],
  },
]
